import Vue from 'vue'
import App from '../../App.vue'
import store from '../../store'
import router from './router'
import filter from 'mobile/js/filter'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { Message} from 'view-design'
import 'view-design/dist/styles/iview.css'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
Vue.use(require('vue-wechat-title'))
Vue.use(VueAwesomeSwiper)

for(let key in filter){
  Vue.filter(key, filter[key])
}
Vue.prototype.$store = store
Vue.config.productionTip = false
Vue.prototype.$Message = Message
Vue.prototype.$Message.config({
  top: 500,
  duration: 3
})
const options = {
	fullscreenEl:false, //关闭全屏按钮
  zoomEl: false,
	bgOpacity : 0.7,
  tapToClose: true
}
Vue.use(preview, options)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
